import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-driver-v1',
  templateUrl: './driver-v1.component.html',
  styleUrls: ['./driver-v1.component.scss'],
})
export class DriverV1Component implements OnInit{
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  isClicked: boolean = false;
  presentComponent: number = 1;
  features = [
    'Dedicated & reservable short and long-term parking',
    'Parking options at secure top-tier lots',
    'Quick & easy access to lot details & booking information',
    'User-friendly app and technology for drivers',
  ];

  ngOnInit(): void {
    localStorage.removeItem('isEmailVerified');
  }

  clickMenu(event: Event) {
    event.stopPropagation();
    this.isClicked = !this.isClicked;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  }
}
